<template>
  <div>
    <div class="row mbl">

      <div class="columns  medium-12">
        <span class="label info">CAMP</span>
        <h4 class="mbn">
          <strong>
            {{ camp.className }} ({{ age }})
          </strong>
        </h4>
        <p class="mbn small">
          {{ campStartDateTime }} - {{ campEndDateTime }}
        </p>
        <h6><strong>{{ camp.venueName }}</strong></h6>
        <p class="mbs" style="white-space: pre-wrap">{{ camp.description }}</p>
      </div>

    </div>

    <div class="row">

      <div class="columns  large-12">
        <table class="full-width">
<!--          <caption align="left">{{ camp.className }} ({{ age }}) {{ campStartDateTime }} - {{ campEndDateTime }}</caption>-->
          <thead>
          <tr>
            <th>Week</th>
            <th>Dates</th>
          </tr>
          </thead>

          <tbody>


          <tr is="Week" v-for="week in camp.weeks" :week="week" :key="week.instanceGroupId">
          </tr>

          </tbody>

        </table>
      </div>

    </div>

    <div class="row">
      <div class="columns">
        <a class="button radius c4k-camp-info-button" :href="viewCampInfoRoute"><i class="fa fa-info-circle"></i> Info &amp; Booking</a>
      </div>
    </div>


    <div class="row divide">
      <div class="columns large-12">
        <hr/>
      </div>
    </div>
  </div>
</template>


<script>
import moment from 'moment';
import Week from './CampWeek';

export default {
  name: 'Camp',
  data: function () {
    return {
      format: 'ddd Do MMMM YYYY',
    };
  },

  props: ['camp'],

  computed: {
    viewCampInfoRoute: function () {
      return Routing.generate('PublicBookingBundle_camp_info', {
        campId: this.camp.campId
      });
    },

    age: function () {
      var ageToInMonths = this.camp.ageToInMonths;
      var ageFromInMonths = this.camp.ageFromInMonths;
      return (
          this.getClassAgeStringFromMonthsCount(ageFromInMonths) +
          ' - ' +
          this.getClassAgeStringFromMonthsCount(ageToInMonths)
      );
    },
    campStartDateTime() {
      return moment.utc(this.camp.startDateTime * 1000).format(this.format);
    },
    campEndDateTime() {
      return moment.utc(this.camp.endDateTime * 1000).format(this.format);
    },
  },

  methods: {
    getClassAgeStringFromMonthsCount: function (months) {
      if (months < 24) {
        return months + ' mths';
      } else if (months % 12 == 0) {
        return months / 12 + 'yrs';
      } else {
        return (
            Math.floor(months / 12) +
            'yrs ' +
            (months % 12) +
            (months > 1 ? 'mths' : 'mth')
        );
      }
    }
  },

  mounted: function () {
  },

  components: {
    Week
  }
};
</script>

<style scoped>
</style>
